import React from "react";

interface KPIWidgetProps {
  title: string;
  value: string | number;
  subtitle?: string;
  accent?: boolean;
  loading?: boolean;
  trend?: string;
  icon?: string;
}

const KPIWidget: React.FC<KPIWidgetProps> = ({ title, value, subtitle, accent, loading, trend, icon }) => {
  return (
    <div className={`kpi-widget ${accent ? "kpi-widget--accent" : ""}`}>
      <div className="kpi-widget-title">
        {icon && <span style={{ marginRight: '0.5rem' }}>{icon}</span>}
        {title}
      </div>
      <div className="kpi-widget-value">
        {loading ? <span className="loading-dots">...</span> : value}
      </div>
      {subtitle && <div className="kpi-widget-subtitle">{subtitle}</div>}
      {trend && (
        <div className="kpi-widget-trend" style={{ fontSize: '0.75rem', marginTop: '0.25rem', color: 'var(--text-muted)' }}>
          {trend === 'up' && '📈 Trending up'}
          {trend === 'down' && '📉 Trending down'}
          {trend === 'neutral' && '➡️ Stable'}
        </div>
      )}
    </div>
  );
};

export default KPIWidget;